











import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class SkeletonBox extends Vue {
  @Prop({ type: String, default: 'div' })
  readonly tag!: string

  @Prop({ type: String, default: 'div' })
  readonly childTag!: string

  @Prop({ type: Object })
  readonly childProps?: Record<string, unknown>

  @Prop({ type: Number, default: 100 })
  readonly maxWidth!: number

  @Prop({ type: Number, default: 80 })
  readonly minWidth!: number

  @Prop({ type: String, default: '%' })
  readonly unit!: string

  @Prop({ type: String, default: '1em' })
  readonly height!: string

  @Prop({ type: String })
  readonly width?: string

  get computedWidth () {
    if (this.width) {
      return this.width
    }

    const min = this.minWidth
    const max = this.maxWidth

    const result = Math.floor((Math.random() * (max - min)) + min)

    return `${result}${this.unit}`
  }
}
